module.exports = __webpack_public_path__ + "img/springroll_fold_0.01a18dd5.jpg";